var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLockSolid = function SvgIconLockSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_lock-solid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_lock-solid_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.32 9.92h-.47c-.66 0-1.29.26-1.75.73-.46.46-.72 1.09-.72 1.75l-.01 5.15h.01c0 .65.26 1.28.72 1.75.46.46 1.09.72 1.75.72h10.3c.66 0 1.29-.26 1.75-.72.46-.47.73-1.1.73-1.75V12.4c0-.66-.27-1.29-.73-1.75-.46-.47-1.09-.73-1.75-.73h-.47V7.98A4.675 4.675 0 0 0 12 3.3a4.675 4.675 0 0 0-4.68 4.68zm2 0h5.36V7.98c0-.71-.28-1.39-.78-1.9-.51-.5-1.19-.78-1.9-.78s-1.39.28-1.89.78a2.68 2.68 0 0 0-.79 1.9z"
  }))));
};
export default SvgIconLockSolid;